import React from "react";
import { WebsiteStatusProvider } from "./provider";
import WebsiteStatusBanner from "./banner";

export const wrapRootElement = ({ element }) => (
  <WebsiteStatusProvider>{element}</WebsiteStatusProvider>
);
export const wrapPageElement = ({ element }) => (
  <>
    <WebsiteStatusBanner />
    {element}
  </>
);
